/* assets/confetti-cart.js — Bokeh shimmer with Android DOM fallback (OPPO/Vivo/OnePlus safe) */
(function () {
  const FIRE_KEY = 'rm_cart_confetti_fired_bokeh_v5';
  const PREV_KEY = 'rm_cart_prev_total_v5';

  let isAnimating = false;
  let debounceId = null;

  /* =================== Detect problematic Android WebViews =================== */
  const UA = navigator.userAgent || '';
  const IS_ANDROID = /Android/i.test(UA);
  const IS_BRAND = /(OPPO|CPH|vivo|Vivo|OnePlus|ONEPLUS|ColorOS|Realme|RMX)/i.test(UA); // include siblings/variants
  const LOW_MEM = (navigator.deviceMemory && navigator.deviceMemory <= 3);
  const PROBLEM_ANDROID = IS_ANDROID && (IS_BRAND || LOW_MEM);

  const IS_DESKTOP = matchMedia('(min-width: 992px)').matches;

  /* ================= Canvas path (kept for iOS/Samsung/desktop) ================= */
  let CANVAS, CTX, CW = 0, CH = 0, DPR = 1;
  let DISC_NEUTRAL = null, STAR_SPRITE = null;

  function ensureCanvas() {
    if (CANVAS) return CANVAS;
    CANVAS = document.getElementById('rm-confetti-canvas') || document.createElement('canvas');
    CANVAS.id = 'rm-confetti-canvas';
    Object.assign(CANVAS.style, {
      position: 'fixed',
      inset: '0',
      width: '100vw',
      height: '100vh',
      pointerEvents: 'none',
      zIndex: '2147483647',
      background: 'transparent'
    });
    if (!CANVAS.parentNode) document.body.appendChild(CANVAS);

    // desynchronized can glitch ColorOS; keep it off on Android
    try {
      CTX = CANVAS.getContext('2d', { alpha: true, desynchronized: false }) || CANVAS.getContext('2d');
    } catch (e) {
      CTX = CANVAS.getContext('2d');
    }

    function resize() {
      const DPR_CAP = IS_DESKTOP ? 1.5 : 1.75;
      DPR = Math.min(DPR_CAP, Math.max(1, window.devicePixelRatio || 1));
      CW = Math.floor(window.innerWidth * DPR);
      CH = Math.floor(window.innerHeight * DPR);
      CANVAS.width = CW; CANVAS.height = CH;
      CTX.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);
    return CANVAS;
  }

  function makeSprite(size, drawFn) {
    const c = document.createElement('canvas');
    c.width = c.height = size;
    const ctx = c.getContext('2d');
    drawFn(ctx, size);
    return c;
  }

  function ensureSprites() {
    if (DISC_NEUTRAL && STAR_SPRITE) return;
    DISC_NEUTRAL = makeSprite(64, (ctx, S) => {
      const r = S / 2;
      const g = ctx.createRadialGradient(r, r, 0, r, r, r);
      g.addColorStop(0.0, 'rgba(250,245,230,0.90)');
      g.addColorStop(0.40, 'rgba(250,245,230,0.55)');
      g.addColorStop(1.0, 'rgba(250,245,230,0.00)');
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(r, r, r, 0, Math.PI * 2); ctx.fill();
    });
    STAR_SPRITE = makeSprite(48, (ctx, S) => {
      ctx.translate(S/2, S/2);
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.beginPath();
      for (let i = 0; i < 10; i++) {
        const a = (i / 10) * Math.PI * 2;
        const rr = i % 2 ? S * 0.12 : S * 0.22;
        ctx.lineTo(Math.cos(a) * rr, Math.sin(a) * rr);
      }
      ctx.closePath(); ctx.fill();
    });
  }

  /* ================= Chrome-desktop tuned canvas burst ================= */
  function canvasConfettiBurst() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    ensureCanvas();
    ensureSprites();

    // Chrome desktop only (exclude Edge/Opera/Brave/Safari/iOS)
    const IS_CHROME_DESKTOP =
      IS_DESKTOP &&
      !PROBLEM_ANDROID &&
      /\bChrome\/\d+/.test(UA) &&
      !/\b(Edg|OPR|Brave|CriOS)\//.test(UA);

    // Palette
    const BASE = ['#D4AF37', '#F2E8C9', '#FFF7E6'];
    const BRAND = '#6d0b0b';
    const BRAND_RATIO = 0.12;

    const cols = Array.from({ length: 100 }, () =>
      Math.random() < BRAND_RATIO ? BRAND : BASE[(Math.random() * BASE.length) | 0]
    );

    // Density
    const cores = navigator.hardwareConcurrency || 4;
    const COUNT = cores >= 8 ? (IS_DESKTOP ? 96 : 84) : (IS_DESKTOP ? 80 : 68);

    // Timing: Chrome desktop runs long + until all pieces are off-screen
    const START     = performance.now();
    const DURATION  = IS_CHROME_DESKTOP ? 14000 : (IS_DESKTOP ? 5200 : 3600); // ms
    const TAIL      = IS_CHROME_DESKTOP ? 2200  : (IS_DESKTOP ? 650  : 300);  // ms
    const END       = START + DURATION;
    const END_TAIL  = END + TAIL;
    const MAX_END   = IS_CHROME_DESKTOP ? (START + 16000) : END_TAIL;         // safety cap

    const W = window.innerWidth;
    const H = window.innerHeight;

    // Speeds: keep feel the same; Chrome desktop starts a hair faster
    const pieces = Array.from({ length: COUNT }, () => {
      const size = 10 + Math.random() * 12;
      const baseVy = IS_CHROME_DESKTOP
        ? (4.2 + Math.random() * 2.0)
        : (IS_DESKTOP ? (4.2 + Math.random() * 2.2) : (3.2 + Math.random() * 1.8));

      return {
        x: Math.random() * W,
        y: -20 - Math.random() * 40,
        vx: (Math.random() - 0.5) * 1.0,
        vy: baseVy,
        size,
        color: cols[(Math.random() * cols.length) | 0],
        phase: Math.random() * Math.PI * 2,
        seed: Math.random() * 1000,
        glint: Math.random() < 0.15
      };
    });

    function drawDisc(x, y, size, tint) {
      CTX.globalCompositeOperation = 'lighter';
      CTX.globalAlpha = 0.5;
      CTX.fillStyle = tint;
      CTX.beginPath(); CTX.arc(x, y, size * 0.4, 0, Math.PI * 2); CTX.fill();
      CTX.globalAlpha = 1;
      const s = size * 1.2;
      CTX.drawImage(DISC_NEUTRAL, x - s / 2, y - s / 2, s, s);
      CTX.globalCompositeOperation = 'source-over';
    }
    function drawStar(x, y, size) {
      const s = size * 0.8;
      CTX.globalCompositeOperation = 'lighter';
      CTX.globalAlpha = 0.6;
      CTX.drawImage(STAR_SPRITE, x - s / 2, y - s / 2, s, s);
      CTX.globalAlpha = 1;
      CTX.globalCompositeOperation = 'source-over';
    }

    let rafId;
    let lastNow = performance.now();

    function cleanup() {
      cancelAnimationFrame(rafId);
      CTX.setTransform(1, 0, 0, 1, 0, 0);
      CTX.clearRect(0, 0, CW, CH);
      CTX.setTransform(DPR, 0, 0, DPR, 0, 0);
    }

    function frame(now) {
      if (document.hidden) { cleanup(); return; }

      // time-based integration for consistent fall across FPS
      let dt = (now - lastNow) / 16.6667; // ~frames
      if (dt > 2) dt = 2;
      lastNow = now;

      CTX.setTransform(1, 0, 0, 1, 0, 0);
      CTX.clearRect(0, 0, CW, CH);
      CTX.setTransform(DPR, 0, 0, DPR, 0, 0);

      const GRAVITY = IS_CHROME_DESKTOP ? 0.042 : (IS_DESKTOP ? 0.038 : 0.035); // keep feel; Chrome only slightly stronger
      const MAX_VY  = IS_CHROME_DESKTOP ? 8.2    : (IS_DESKTOP ? 7.6   : 6.8);

      for (const p of pieces) {
        p.x += (p.vx + Math.sin(p.y * 0.01 + p.seed) * 0.18) * dt;
        p.vy = Math.min(p.vy + GRAVITY * dt, MAX_VY);
        p.y += p.vy * dt;

        const twinkle = 0.55 + Math.sin(p.phase + p.y * 0.03) * 0.25;
        CTX.globalAlpha = twinkle;
        drawDisc(p.x, p.y, p.size, p.color);
        if (p.glint && Math.random() < 0.7) { CTX.globalAlpha = 0.35; drawStar(p.x, p.y, p.size); }
        CTX.globalAlpha = 1;
      }

      if (IS_CHROME_DESKTOP) {
        // Keep going until everything is off-screen (or safety cap)
        const allBelow = pieces.every(p => p.y > H + 24);
        if (!allBelow && now < MAX_END) {
          rafId = requestAnimationFrame(frame);
        } else {
          cleanup();
        }
      } else {
        if (now < END_TAIL) rafId = requestAnimationFrame(frame);
        else cleanup();
      }
    }

    requestAnimationFrame(frame);
  }

  /* ======================= DOM fallback (Android safe) ======================= */
  function domConfettiBurst() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const layer = document.createElement('div');
    layer.id = 'rm-confetti-dom';
    Object.assign(layer.style, {
      position: 'fixed',
      inset: '0',
      pointerEvents: 'none',
      zIndex: '2147483647',
      overflow: 'hidden'
    });
    document.body.appendChild(layer);

    const BASE = ['#D4AF37', '#F2E8C9', '#FFF7E6'];
    const BRAND = '#6d0b0b';
    const BRAND_RATIO = 0.12;

    const cols = Array.from({length: 100}, () =>
      Math.random() < BRAND_RATIO ? BRAND : BASE[(Math.random()*BASE.length)|0]
    );

    const cores = navigator.hardwareConcurrency || 4;
    const COUNT = (cores >= 8) ? 70 : 56;   // light on Android
    const DURATION = 2800;
    const END = performance.now() + DURATION;

    const W = window.innerWidth, H = window.innerHeight;

    const pieces = [];
    const frag = document.createDocumentFragment();

    function hexToRgb(hex) {
      const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return m ? { r: parseInt(m[1],16), g: parseInt(m[2],16), b: parseInt(m[3],16) } : {r:255,g:255,b:255};
    }

    for (let i = 0; i < COUNT; i++) {
      const el = document.createElement('i');
      const size = 8 + Math.random()*10;
      const color = cols[(Math.random()*cols.length)|0];
      const rgb = hexToRgb(color);

      Object.assign(el.style, {
        position: 'absolute',
        left: '0', top: '0',
        width: size + 'px',
        height: size + 'px',
        borderRadius: '999px',
        background: `rgba(${rgb.r},${rgb.g},${rgb.b},0.85)`,
        boxShadow: `0 0 ${Math.round(size*1.2)}px rgba(${rgb.r},${rgb.g},${rgb.b},0.45)`,
        opacity: '0.9',
        willChange: 'transform, opacity',
        transform: `translate3d(${Math.random()*W}px, ${(-20 - Math.random()*40)}px, 0)`,
        transition: 'none'
      });

      frag.appendChild(el);

      pieces.push({
        el,
        x: Math.random()*W,
        y: -20 - Math.random()*40,
        vx: (Math.random()-0.5)*0.9,
        vy: 3.1 + Math.random()*1.7,
        size,
        phase: Math.random()*Math.PI*2,
        seed: Math.random()*1000,
        glint: Math.random() < 0.12
      });
    }
    layer.appendChild(frag);

    let rafId;
    function cleanup() {
      cancelAnimationFrame(rafId);
      try { document.body.removeChild(layer); } catch(_) {}
    }

    function frame(now) {
      if (document.hidden) { cleanup(); return; }

      for (const p of pieces) {
        p.x += p.vx + Math.sin(p.y*0.01 + p.seed)*0.16;
        p.y += p.vy;
        const tw = 0.55 + Math.sin(p.phase + p.y*0.03)*0.25;
        p.el.style.opacity = String(tw);
        p.el.style.transform = `translate3d(${p.x}px, ${p.y}px, 0)`;
      }

      const TAIL = 250;
      if (now < END + TAIL) rafId = requestAnimationFrame(frame);
      else cleanup();
    }
    requestAnimationFrame(frame);
  }

  /* ====================== UI accents: goal glow + pulse ====================== */
  function glowGoalBar() {
    const el = document.getElementById('cart-goal-bar');
    if (!el) return;
    const BURST_MS = 2200, HOLD_MS = 2500;
    el.classList.remove('goal-bar--glow', 'goal-bar--glow-hold');
    void el.offsetWidth;
    el.classList.add('goal-bar--glow');
    setTimeout(() => el.classList.add('goal-bar--glow-hold'), BURST_MS);
    setTimeout(() => el.classList.remove('goal-bar--glow', 'goal-bar--glow-hold'), BURST_MS + HOLD_MS);
  }

  function pulseCheckout() {
    const btn =
      document.querySelector('form[action*="/cart"] button[name="checkout"]') ||
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('[href*="checkout"]');
    if (!btn) return;
    btn.classList.remove('checkout-pulse');
    void btn.offsetWidth;
    btn.classList.add('checkout-pulse');
    setTimeout(() => btn.classList.remove('checkout-pulse'), 900);
  }

  function celebrateOnce() {
    if (isAnimating) return;
    isAnimating = true;
    if (PROBLEM_ANDROID) domConfettiBurst(); else canvasConfettiBurst();
    glowGoalBar();
    pulseCheckout();
    setTimeout(() => { isAnimating = false; }, 4200);
  }

  /* ====================== Threshold crossing detection ====================== */
  function readTotalsFromDOM() {
    const bar = document.getElementById('cart-goal-bar');
    if (!bar) return null;
    const goal = parseInt(bar.getAttribute('data-goal') || String(window.__CART_GOAL_CENTS || 0), 10);
    const total = parseInt(bar.getAttribute('data-total') || '0', 10);
    if (Number.isNaN(goal) || Number.isNaN(total)) return null;
    return { goal, total, el: bar };
  }

  function evaluate(total, goal) {
    if (typeof total !== 'number' || typeof goal !== 'number') return;
    const prev  = parseInt(sessionStorage.getItem(PREV_KEY) || '0', 10);
    const fired = sessionStorage.getItem(FIRE_KEY) === '1';
    const wasUnlocked = prev >= goal;
    const isUnlocked  = total >= goal;
    sessionStorage.setItem(PREV_KEY, String(total));
    if (!isUnlocked && fired) sessionStorage.removeItem(FIRE_KEY);
    if (!wasUnlocked && isUnlocked && !fired) {
      celebrateOnce();
      sessionStorage.setItem(FIRE_KEY, '1');
    }
  }

  function checkNow() {
    const d = readTotalsFromDOM();
    if (!d) return;
    evaluate(d.total, d.goal);
  }

  function debounceCheck(delay = 140) {
    clearTimeout(debounceId);
    debounceId = setTimeout(checkNow, delay);
  }

  /* ====================== Event wiring (minimal & safe) ====================== */
  function wireOnce() {
    document.addEventListener('cart:updated', () => debounceCheck(120));
    document.addEventListener('cart:change',  () => debounceCheck(120));
    document.addEventListener('cart:refresh', () => debounceCheck(120));
    document.addEventListener('shopify:section:load',   () => debounceCheck(120));
    document.addEventListener('shopify:section:select', () => debounceCheck(120));

    const d = readTotalsFromDOM();
    if (d && !d.el._confettiObs) {
      const obs = new MutationObserver(() => debounceCheck(60));
      obs.observe(d.el, { attributes: true, attributeFilter: ['data-total','data-goal'] });
      d.el._confettiObs = obs;
    }

    const root =
      document.querySelector('#main-cart-items .js-contents') ||
      document.getElementById('main-cart-items') ||
      document.querySelector('cart-items');

    if (root && !root._confettiDomObs) {
      const domObs = new MutationObserver(() => debounceCheck(100));
      domObs.observe(root, { childList: true, subtree: true });
      root._confettiDomObs = domObs;
    }

    document.addEventListener('click', (e) => {
      if (e.target.closest('.quantity__button, cart-remove-button a, button[name="update"]')) {
        debounceCheck(150);
      }
    });
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="updates[]"]')) debounceCheck(150);
    });

    document.addEventListener('visibilitychange', () => { if (!document.hidden) debounceCheck(80); });
    window.addEventListener('pageshow', () => debounceCheck(80));
  }

  function boot() {
    wireOnce();
    debounceCheck(80);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* ====================== Console helpers ====================== */
  window._cartConfettiDebug = function () {
    const d = readTotalsFromDOM();
    console.log('confetti debug →', {
      goal: d && d.goal,
      total: d && d.total,
      prev: sessionStorage.getItem(PREV_KEY),
      fired: sessionStorage.getItem(FIRE_KEY),
      PROBLEM_ANDROID
    });
    return d;
  };
  window._cartConfettiNudge = () => debounceCheck(60);
  window._cartConfettiTest = () => (PROBLEM_ANDROID ? domConfettiBurst() : canvasConfettiBurst());
})();
